var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.4966 34.7126L27.4692 27.6838L34.4566 20.7538C34.9835 20.2322 34.9835 19.3878 34.4566 18.8675C33.931 18.3473 33.0773 18.3473 32.5517 18.8675L25.5736 25.7882L18.4915 18.7048C17.9659 18.1765 17.1121 18.1765 16.5866 18.7048C16.061 19.2317 16.061 20.0881 16.5866 20.6151L23.658 27.6878L16.5465 34.7406C16.0209 35.2622 16.0209 36.1066 16.5465 36.6269C17.0721 37.1484 17.9259 37.1484 18.4528 36.6269L25.5549 29.5834L32.593 36.6215C33.1186 37.1498 33.9724 37.1498 34.498 36.6215C35.0222 36.0959 35.0222 35.2408 34.4966 34.7126Z",
    fill: "#203468"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuClose);
export default __webpack_public_path__ + "static/media/menu_close.868c199fb298c33f59b02cbd1dca5a0e.svg";
export { ForwardRef as ReactComponent };